import React from 'react';
import { connect } from 'react-redux';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import Logo from '../../global/img/logo_full_white.png';
import SocialLinks from '../SocialLinks';
import './style.css';


function NavbarHeader(props) {
	const { user, dispatch } = props;

	return (
		<>
			<Navbar id='menu' collapseOnSelect expand='lg' className='bg-body-tertiary' sticky='top'>
				<div className='navbarContainer'>
					<Navbar.Toggle className='toggleMenu' aria-controls='responsive-navbar-nav'>
						<div className='toggleMenuDiv'>
							<span className='toggleMenuLine' />
							<span className='toggleMenuLine' />
							<span className='toggleMenuLine' />
						</div>
					</Navbar.Toggle>
					<a href='/' className='logoLinkMobile'>
						<img src={Logo} alt='Logo' className='logo' />
					</a>
					<Navbar.Collapse id='responsive-navbar-nav'>
						<Nav className='me-auto'>
							<Nav.Link href='/' className='hideMobile'>
								<img src={Logo} alt='Logo' className='logo' />
							</Nav.Link>
						</Nav>
						<Nav>
							<Nav.Link eventKey={10} href='/fantasy' className='fantasyNavLink'>
								FANTASY PICK
								<span className='fantasyNewBadge'>New!</span>
							</Nav.Link>
							<Nav.Link eventKey={2} href='/nfl/upcominggames'>
								NFL
							</Nav.Link>
							{/* <Nav.Link eventKey={9} href='/cfb/upcominggames'>
								CFB
							</Nav.Link> */}
							{/* <Nav.Link eventKey={4} href='/soccer/upcominggames'>
								SOCCER
							</Nav.Link> */}
							<NavDropdown title={<span onClick={(e) => e.preventDefault()}>SOCCER</span>} id="soccer-nav-dropdown">
								<NavDropdown.Item href='/soccer/upcominggames?league=EPL'>EPL</NavDropdown.Item>
								<NavDropdown.Item href='/soccer/upcominggames?league=ESP'>La Liga</NavDropdown.Item>
   						    </NavDropdown>
							<Nav.Link eventKey={3} href='/nba/upcominggames'>
								NBA
							</Nav.Link>
							<Nav.Link eventKey={8} href='/cricket/upcominggames?league=IPL'>
								IPL
							</Nav.Link>
							<Nav.Link eventKey={4} href='/articles'>
								BREAKING NEWS
							</Nav.Link>
							<Nav.Link eventKey={5} href='/about'>
								ABOUT
							</Nav.Link>
							<Nav.Link eventKey={6} href='/whitepaper'>
								WHITEPAPER
							</Nav.Link>
							{user?.admin ? (
								<NavDropdown title="ADMIN" id="admin-nav-dropdown">
									<NavDropdown.Item href="/admin">Dashboard</NavDropdown.Item>
									<NavDropdown.Item href="/admin-panel/articles">Articles</NavDropdown.Item>
									<NavDropdown.Item href="/admin-panel/email-marketing">Email Marketing</NavDropdown.Item>
									<NavDropdown.Item href="/admin-panel/dfs-picks">DFS Picks</NavDropdown.Item>
									<NavDropdown.Item href="/admin-panel/tbd-return-dates">TBD Return Dates</NavDropdown.Item>
								</NavDropdown>
							) : null}
							{user?.login ? <Nav.Link eventKey={7} href='/profile'>
								PROFILE
							</Nav.Link> : null}
							<Nav.Link
								eventKey={6}
								href="/login"
								onClick={() => user?.login && dispatch({ type: "LOGOUT" })}
							>
								{!user?.login ? "LOGIN" : "LOGOUT"}
							</Nav.Link>
							<Nav.Item className='headerSocialNavItem'>
								<SocialLinks
									className='headerSocialLinks'
									linkClassName='headerSocialLink'
									iconClassName='headerSocialIcon'
								/>
							</Nav.Item>
						</Nav>
					</Navbar.Collapse>
				</div>
			</Navbar>
		</>
	);
}

const mapStateToProps = (state) => ({
	options: state.options,
	user: state.user,
	userActions: state.userActions,
	passwordReset: state.passwordReset
});

export default connect(mapStateToProps)(NavbarHeader);
